export default __webpack_public_path__ + "static/media/15.179ea1dd.jpeg";